import { ArrowRight, Check, Clock3 } from 'lucide-react';
import type { Service } from '@/types/domain/service';
import type { User } from '@/types/domain/user';
const currency = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export function WalkInServices({
  services,
  selectedIds,
  onToggle,
}: {
  services: Service[];
  selectedIds: Set<string>;
  onToggle: (id: string) => void;
}) {
  return (
    <div className="space-y-3">
      {!services.length && <p role="status">Este local ainda não tem serviços disponíveis.</p>}
      {services.map((service) => {
        const selected = selectedIds.has(service.id);
        return (
          <button
            key={service.id}
            type="button"
            aria-pressed={selected}
            onClick={() => onToggle(service.id)}
            className={`focus-visible:ring-primary flex w-full items-center gap-4 rounded-2xl border-2 p-4 text-left transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 ${selected ? 'border-primary bg-primary-light' : 'border-border bg-card hover:border-primary/40'}`}
          >
            <span className="min-w-0 flex-1">
              <span className="block font-semibold">{service.name}</span>
              <span className="mt-2 block text-sm font-semibold sm:hidden">{currency.format(service.price)}</span>
              <span className="text-muted-foreground mt-1 flex items-center gap-1 text-xs">
                <Clock3 className="h-3 w-3" aria-hidden="true" />
                {service.durationMin} min de atendimento
              </span>
            </span>
            <span className="hidden shrink-0 text-sm font-semibold sm:block">{currency.format(service.price)}</span>
            <span
              className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border ${selected ? 'bg-primary border-primary text-primary-foreground' : 'border-border'}`}
            >
              {selected && <Check className="h-4 w-4" aria-hidden="true" />}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export function WalkInProfessionals({
  professionals,
  professionalId,
  onSelect,
}: {
  professionals: User[];
  professionalId: string;
  onSelect: (id: string) => void;
}) {
  return (
    <div className="grid gap-3">
      {!professionals.length && <p role="status">Nenhum profissional disponível neste local.</p>}
      {professionals.map((person) => (
        <button
          key={person.id}
          type="button"
          aria-label={person.name}
          aria-pressed={professionalId === person.id}
          onClick={() => onSelect(person.id)}
          className={`focus-visible:ring-primary flex min-h-24 items-center gap-3 rounded-2xl border-2 p-4 text-left transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 ${professionalId === person.id ? 'border-primary bg-primary-light' : 'border-border bg-card hover:border-primary/40'}`}
        >
          <img
            src={person.photo || '/person-placeholder.jpg'}
            alt=""
            className="h-12 w-12 shrink-0 rounded-full object-cover"
          />
          <span className="min-w-0 flex-1">
            <span className="block font-semibold">{person.name}</span>
            <span className="text-primary mt-1 flex items-center gap-1 text-sm">
              Entrar nesta fila <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </span>
          </span>
          {professionalId === person.id && <Check className="text-primary h-5 w-5" aria-hidden="true" />}
        </button>
      ))}
    </div>
  );
}
